import { useState, useEffect } from 'react'
import { lumi } from '../lib/lumi'
import { auditHelpers } from '../utils/auditLogger'

export function useAuth() {
  const [user, setUser] = useState(lumi.auth.user)
  const [isAuthenticated, setIsAuthenticated] = useState(lumi.auth.isAuthenticated)

  useEffect(() => {
    let mounted = true;
    const unsubscribe = lumi.auth.onAuthChange(({ isAuthenticated, user }) => {
      if (mounted) {
        setUser(user)
        setIsAuthenticated(isAuthenticated)
      }
    })
    return () => {
      mounted = false;
      unsubscribe();
    }
  }, [])

  const handleSignIn = async () => {
    try {
      await lumi.auth.signIn()
      if (lumi.auth.user) {
        await auditHelpers.logLogin(lumi.auth.user.userId)
      }
    } catch (error: any) {
      if (error.message === 'Auth window closed') {
        // User closed the auth window, silently ignore
        console.log('Login cancelado pelo usuário')
      } else {
        console.error('Erro ao fazer login:', error)
      }
    }
  }

  return {
    user,
    isAuthenticated,
    isAdmin: user?.userRole === 'ADMIN',
    isUser: user?.userRole === 'USER',
    signIn: handleSignIn,
    signOut: () => lumi.auth.signOut(),
  }
}
